export const APP_REFRESH_INTERVAL_IN_MS = 300000;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE_NUMBER = 1;
